import { array, coerce, enum as enumFactory, iso, literal, number, strictObject, string } from "../../lazy-zod.js";
import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import { inboxItemSchema } from "./inbox.js";
//#region src/schemas/http/inbox-feed.ts
const opaqueKeySchema = string().min(1).max(4096).regex(/^[A-Za-z0-9_-]+$/u);
const identifierSchema = string().trim().min(1).max(256);
const countSchema = number().int().nonnegative();
const inboxFeedCategorySchema = enumFactory([
	"all",
	"mentions",
	"needs_action",
	"needs_review"
]);
const inboxFeedQuerySchema = strictObject({
	category: inboxFeedCategorySchema.optional(),
	unreadOnly: enumFactory(["true", "false"]).optional(),
	agentsOnly: enumFactory(["true", "false"]).optional(),
	peopleOnly: enumFactory(["true", "false"]).optional(),
	conversationType: enumFactory([
		"all",
		"direct_messages",
		"spaces"
	]).optional(),
	includeSelectionUnreadCount: literal("true").optional(),
	cursor: string().min(1).max(8192).optional(),
	limit: coerce.number().int().min(1).max(100).optional(),
	snapshotId: identifierSchema.optional(),
	groupKey: opaqueKeySchema.optional()
});
const inboxFeedCountsSchema = strictObject({
	all: countSchema,
	mentions: countSchema,
	needsAction: countSchema,
	needsReview: countSchema,
	unread: countSchema,
	priority: countSchema
});
const inboxFeedRowSchema = strictObject({
	groupKey: opaqueKeySchema,
	item: inboxItemSchema,
	itemCount: number().int().positive(),
	unreadCount: countSchema,
	latestOccurredAt: iso.datetime({ offset: true }),
	section: enumFactory([
		"priority",
		"open",
		"activity"
	]),
	requestCategory: enumFactory(["action", "review"]).nullable(),
	dot: enumFactory(["blue", "yellow"]).nullable()
});
const inboxFeedResponseSchema = strictObject({
	organizationId: identifierSchema,
	snapshotId: identifierSchema,
	snapshotExpiresAt: iso.datetime({ offset: true }),
	counts: inboxFeedCountsSchema,
	selectionUnreadCount: countSchema.optional(),
	rows: array(inboxFeedRowSchema).max(100),
	nextCursor: string().nullable()
});
const mutateInboxFeedBodySchema = strictObject({
	snapshotId: identifierSchema,
	groupKey: opaqueKeySchema.optional(),
	operation: enumFactory(["read", "dismiss"])
});
const mutateInboxFeedResponseSchema = strictObject({ changedCount: countSchema });
const listInboxFeedRpcInputSchema = inboxFeedQuerySchema.extend({ context: openMeldRequestContextSchema });
const mutateInboxFeedRpcInputSchema = mutateInboxFeedBodySchema.extend({ context: openMeldRequestContextSchema });
//#endregion
export { inboxFeedCategorySchema, inboxFeedCountsSchema, inboxFeedQuerySchema, inboxFeedResponseSchema, inboxFeedRowSchema, listInboxFeedRpcInputSchema, mutateInboxFeedBodySchema, mutateInboxFeedResponseSchema, mutateInboxFeedRpcInputSchema };

//# sourceMappingURL=inbox-feed.js.map